<ng-select
  [(ngModel)]="selectedId"
  (ngModelChange)="onModelChange()"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [clearable]="clearable"
  [searchable]="searchable"
>
  <ng-option *ngFor="let channel of channels" [value]="channel.id">
    <img alt="" class="avatar mr-1" [src]="channel.avatarPath" />
    {{ channel.label }}
  </ng-option>
</ng-select>
